import { useFormikContext } from 'formik'
import { useDebounce } from 'react-use'

export const AutoSubmit = ({ submitTime, onAutoSubmit }) => {
	const formikContext = useFormikContext()
	const { values, dirty, isValid, submitForm, isSubmitting } = formikContext

	useDebounce(
		() => {
			if (dirty && isValid && !isSubmitting) {
				const submitFunction = onAutoSubmit || submitForm
				submitFunction(values, { ...formikContext, isAutoSubmit: true })
			}
		},
		submitTime,
		[values, dirty]
	)

	return null
}

AutoSubmit.defaultProps = {
	submitTime: 5000,
}
